import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import pos_exam from "../../constants/Pos_questions.json";
import { Container, Segment, Item, Button, Message } from "semantic-ui-react";
import Exam_vector from "../../../../../assets/Icon/Exam_Vector2.png";

import Offline from "../Offline";
import { BASE_URL } from "../../../../../baseurl";
import axios from "axios";

const Main = ({ startQuiz }) => {
  const [category, setCategory] = useState("0");
  const [numOfQuestions, setNumOfQuestions] = useState(5);
  const [difficulty, setDifficulty] = useState("easy");
  const [questionsType, setQuestionsType] = useState("0");
  const [countdownTime, setCountdownTime] = useState({
    hours: 3600,
    minutes: 0,
    seconds: 0,
  });
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);
  const [offline, setOffline] = useState(false);

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);

  const handleTimeChange = (e, { name, value }) => {
    setCountdownTime({ ...countdownTime, [name]: value });
  };
  // console.log(countdownTime && true);
  let allFieldsSelected = false;
  if (
    category &&
    numOfQuestions &&
    difficulty &&
    questionsType &&
    (countdownTime.hours || countdownTime.minutes || countdownTime.seconds)
  ) {
    allFieldsSelected = true;
  }

  const fetchData = async () => {
    setProcessing(true);

    if (error) setError(null);

    const API = `${BASE_URL}/user/exam/getQuestion`;

    try {
      let token = localStorage.getItem("user_token");
      const res = await fetch(`${API}`, {
        headers: { Authorization: token },
      });
      console.log(res, "checkres");
      const data = await res.json();

      // console.log(data.data)
      console.log(data, "chekcquestiondata");

      setProcessing(false);
      startQuiz(
        data.data,
        countdownTime.hours + countdownTime.minutes + countdownTime.seconds
      );
    } catch (e) {
      if (!navigator.onLine) {
        setOffline(true);
      } else {
        setProcessing(false);
        setError(error);
      }
    }
  };

  const getCertificateData = async () => {
    try {
      let token = localStorage.getItem("user_token");
      let res = await axios.get(`${BASE_URL}/user/data/getDetails`, {
        headers: {
          Authorization: token,
        },
      });
      let data = res.data;
      setLoading(false);
      if (res.status == 200) {
        setData(res?.data?.data);
      }
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  };

  const getTotalVideoCount = async () => {
    try {
      let token = localStorage.getItem("user_token");
      let res = await axios.get(`${BASE_URL}/user/video/totalVideoCount`, {
        headers: {
          Authorization: token,
        },
      });

      if (res.status == 200) {
        setCount(res?.data?.data);
      }
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  };

  useEffect(() => {
    getCertificateData();
    getTotalVideoCount();
  }, []);
  console.log(data?.videoCount, "checkdata--->>>", "setCount ", count);

  if (offline) return <Offline />;

  return (
    <Container>
      {!loading ? (
        data?.videosWatched ? (
          <>
            <Segment>
              <Item.Group divided>
                <Item>
                  {/* <Item.Image src={mindImg} /> */}
                  <Item.Content>
                    <Item.Header>
                      <h1></h1>
                    </Item.Header>
                    {error && (
                      <Message error onDismiss={() => setError(null)}>
                        <Message.Header>Error!</Message.Header>
                        {error.message}
                      </Message>
                    )}

                    <Item.Extra>
                      <section class="">
                        <div class="h-full">
                          {/* <!-- Left column container with background--> */}
                          <div class="g-6 flex h-full flex-wrap items-center justify-center ">
                            <div class="shrink-1 mb-12 grow-0 basis-auto md:mb-0 md:w-9/12 md:shrink-0 lg:w-6/12 xl:w-6/12">
                              <img
                                src={Exam_vector}
                                class="w-full"
                                alt="Sample image"
                              />
                            </div>

                            {/* <!-- Right column container --> */}
                            <div class="mb-12 md:mb-0 md:w-8/12 lg:w-5/12 xl:w-5/12">
                              <div className="exam-intro-container p-5 leading-10 text-[16px] text-black">
                                <h2 className="Exam_Header_first font-worksans">
                                  Welcome to the Sales Proficiency Exam!
                                </h2>
                                <p className="Exam_Header_text font-worksans">
                                  This exam is designed to evaluate your
                                  knowledge and skills as a POSP.
                                </p>
                                <p className="Exam_Header_text worksans">
                                  It consists of multiple-choice questions
                                  covering various aspects of sales, including
                                  fundamentals, product knowledge, closing
                                  techniques, and sales ethics.
                                </p>
                                <p className="font-bold">Instructions:</p>
                                <ul className="Exam_Header_text worksans ">
                                  <li className="Exam_Header_text worksans mt-[5px]">
                                    Read each question carefully before
                                    selecting an answer.
                                  </li>
                                  <li className="Exam_Header_text worksans mt-[5px]">
                                    Choose the best answer for each question;
                                    there is only one correct answer.
                                  </li>
                                  <li className="Exam_Header_text worksans mt-[5px]">
                                    Click "Submit" when you have answered all
                                    the questions.
                                  </li>
                                  <li className="Exam_Header_text worksans mt-[5px]">
                                    Your results will be displayed at the end of
                                    the exam.
                                  </li>
                                </ul>
                                <p className="Exam_Header_text worksans">
                                  Best of luck! Let's get started.
                                </p>
                                <div className="mt-[5px]">
                                  <Button
                                    primary
                                    size="big"
                                    icon="play"
                                    labelPosition="left"
                                    content={
                                      processing ? "Processing..." : "Start Now"
                                    }
                                    onClick={fetchData}
                                    disabled={!allFieldsSelected || processing}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </Item.Extra>
                  </Item.Content>
                </Item>
              </Item.Group>
            </Segment>
            <br />
          </>
        ) : (
          <>
            <div className="flex justify-center items-center">
              <div className="p-8 bg-white rounded-lg shadow-lg flex flex-col items-center gap-4">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-[80px] h-[80px] text-orange-500"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                </div>
                <p className="text-center text-orange-500 font-semibold text-lg">
                  Completion of the training program is a prerequisite
                  <br /> for eligibility to undertake the examination.
                </p>
              </div>
            </div>
          </>
        )
      ) : (
        <div className="m-auto mt-5 w-[40%]">
          <div className="flex justify-center items-center absolute inset-0">
            <div className="animate-spin rounded-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-16 h-16"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                />
              </svg>
            </div>
          </div>
        </div>
      )}
    </Container>
  );
};

Main.propTypes = {
  startQuiz: PropTypes.func.isRequired,
};

export default Main;
